import React from 'react';
import { Form, Input } from 'antd';
import valid from 'card-validator';
import InputMask from 'react-input-mask';
import useElements from '../../hooks/useElements';

const elementType = 'cvv';
function CardCvcElement({ onChange, defaultValue, placeholder = 'CVV' }) {
  const form = Form.useFormInstance();
  const [_, setElements] = useElements();

  return (
    <Form.Item 
      name={elementType}
      label={placeholder}
      initialValue={defaultValue}
      rules={[
        { required: true, message: `${placeholder} é obrigatório.`, },
        { min: 3, message: `${placeholder} deve conter no mínimo 3 caracteres.` },
        { 
          validator: (_, original_value) => {
            const value = (original_value || '').replace(/[ ,D,_]/gi, '');
            const validation = valid.cvv(value);
            const { isValid } = validation || {};
            return isValid ? Promise.resolve() : Promise.reject(new Error('Should accept agreement'))
          },
          message: `${placeholder} não é válido.`
        },
      ]}
    >
      <InputMask
        mask="999"
        maskChar="_"
        onChange={() => {
          if (!onChange) return;
          setTimeout(() => {
            const errors = form.getFieldError(elementType);
            const payload = {
              elementType,
              complete: errors.length <= 0, 
              errors,
            };
            setElements((oldState) => ({ ...oldState, [elementType]: payload }));
            onChange(payload);
          }, 1);
        }}
      >
        {() => (
          <Input 
            id={`${elementType}-input`}
            placeholder={placeholder}  
            size="large" 
          />
        )}
      </InputMask>
    </Form.Item>
  )
};

export default CardCvcElement;